const PostCreateDateParser = (createDate) => new Date(createDate).toLocaleString();

export default PostCreateDateParser;
